module.exports = __webpack_public_path__ + "static/online-blue-f44bca734e003677bb5741b007409f18.svg";